export default {
    'Number': '序号',
    'NoData': '暂无内容',
    'Cancel': '取消',
    'OK': '确定',
    'Import': '导入',
    'StartImport': '开始导入',
    'importWorkflowTips': '流程视图不可导入',
    'ImportData': '导入数据',
    'ReImport': '重新导入',
    'ReUpload': '重新上传',
    'Skip': '跳过',
    'SureImport': '确定导入',
    'ExportFailure': '导出失败',
    'ExportLoading': '正在生成Excel表，请稍候...',
    'AllBeShown': '已展示全部内容',
    'DeleteItems': '以下数据删除后不能恢复，确定要删除吗？',
    'BizData': '业务数据',
    'wlData1': '未关联父子流程的流程数据',
    'wlData2': '已关联子流程的父流程数据',
    'wlData3': '子流程数据',
    'DeleteItems1': '数据删除后，将同步删除已产生的流程实例',
    'DeleteItems2': '父流程删除后将同步删除与其绑定的子流程数据及实例',
    'DeleteItems3': '子流程删除后将同步删除实例及与父流程产生的映射关系',
    'NotAllowedDelete': '普通用户不可删除非草稿流程数据',
    'NotDraftDelete': '流程草稿数据',
    'BusinessRuleException': '【{schemaName}】的【{businessRuleName}】业务规则的【{nodeName}】节点中使用的数据项【{propertyCode}】在系统中不存在，请联系管理员处理！',
    'LogicCheckException': '【{nodeName}】未在目标模型【{targetSchemaName}】中找到满足条件的校验数据',
    'Items': '条',
    'NoPermissionAdd': '您没有发起流程的权限',
    'NoPublish': '流程还未发布',
    'NoPermissionDelete': '您对这些数据没有删除权限',
    'DeleteItemsTips': '成功删除{successCount}条数据，有{errorCount}条数据没有删除权限',
    'DeleteFailed': '删除失败',
    'DeleteLoading': '删除中',
    'DeleteSuccess': '删除成功',
    'GenerationFailed': '文件生成失败，请重新选择',
    'FileIsBeingExported': '文件正在导出中',
    'Query': '查询',
    'Add': '新增',
    'Reset': '重置',
    'More': '更多',
    'TakeUp': '收起',
    'Delete': '删除',
    'DeleteTips1': '以下数据删除后不能恢复',
    'NoSearchResult': '暂无搜索结果',
    'ContentLoadingFailed': '内容加载失败',
    'Refresh': '刷新',
    'Loading': '加载中',
    'ImportTips1': '为确保上传数据与列表内容匹配，请先',
    'ImportTips2': '下载示例文件',
    'ImportTips3': '支持.xlsx格式，文件大小不限',
    'ImportTips4': '导入数据过程中请不要关闭页面，避免导入错误',
    'ImportTips5': '系统异常，导入失败！请重新导入',
    'ImportTips6': '导入成功{num}条',
    'ImportTips7': '导入失败{num}条',
    'ImportTips8': '重新编辑后可再次导入',
    'ImportTips9': '您的数据已超过500条，请删除部分数据或分批重新上传',
    'ImportTips10': '当前文件内的列标题与此列表不一致，请参照',
    'ImportTips11': '只能上传一个文件',
    'ImportWarn': '不支持导入流程数据，导入前请仔细核对!',
    'ImportLocalFaile': '上传本地文件',
    'ClickToImport': '点击或拖拽上传',
    'DownloadFailed': '下载失败',
    'Importing': '导入中',
    'ImportSuccess': '导入成功',
    'ImportTestError': '列表数据重新导入时参数校验失败！',
    'ImportFailed': '导入失败',
    'DownloadFailedList': '下载失败列表',
    'SampleFile': '示例文件',
    'Recheck': '重新检查',
    'ChooseQueryFiled': '选择查询字段',
    'ChooseQueryFiledTips': '导入时会根据查询字段查询是否已有数据，如果存在已有数据，就覆盖导入，如果不存在就新增导入，只支持数据标题、单据号、短文本类数据项',
    'Total': '共{num}条',
    'Screen': '筛选',
    'SetDisplayItems': '字段设置',
    'FormTrack': '表单留痕',
    'Comment': '评论',
    'CopyLink': '复制链接',
    'CopySuccess': '复制成功',
    'CopyFailed': '复制失败',
    'OpenInNewPage': '新页面打开',
    'recovery': '恢复默认设置',
    'chooseColumns': '请设置展示字段',
    'dragToSort': '长按可对字段进行拖拽排序',
    'checkAll': '全选',
    'checkAll1': '选择全部字段',
    'mainTableField': '主表字段',
    'printQrcode': '打印二维码',
    'qrcode': '二维码',
    'dingtalk': '钉钉',
    'enterpriseWechet': '企业微信',
    'scanCodeView': '{equip}扫码查看数据',
    'scanCodeFill': '{equip}扫码填写数据',
    'totalTip': '当前共计{total}条数据；请在预览时扫描二维码检查打印数据是否正确',
    'chooseTagSize': '标签纸尺寸',
    'width': '宽',
    'height': '高',
    'qrcodeText': '标题',
    'qrcodeSet': '二维码设置',
    'bizDataItem': '业务数据项',
    'sysDataItem': '系统数据项',
    'textNumber': '字号',
    'mostShowOne': '最多可展示一行内容',
    'example': '示例图',
    'qrcodeTextExample': '二维码文案示例',
    'preview': '预览',
    'changeBefore': '变更前：',
    'changeAfter': '变更后：',
    'download': '下载',
    'print': '打印预览',
    'pleaseSelect': '请选择',
    'recentSearch': '最近搜索',
    'noMatchResults': '无匹配结果',
    'startExport': '开始导出',
    'export': '导出',
    'exportData': '选择表头导出内容',
    'exportTips': '系统将导出勾选字段数据',
    'loading': '正在生成中',
    'importTitleTips': '请确认【选人控件名称】重复/空数据的值',
    'chooseUser': '选择人员',
    'chooseData': '请先选择数据！',
    'chooseSheetData': '请先选择当前子表数据！',
    'null': '空',
    'notData': '必填数据缺失',
    'dataRepeat': '重复',
    'dataNoExisted': '不存在',
    'dataDeptDisable': '部门禁用',
    'onlyDataDept': '只限单选',
    'repeat': '（重复）',
    'noExisted': '（不存在）',
    'deptDisable': '（部门禁用）',
    'onlyData': '（只限单选）',
    'loadMore': '查看更多数据',
    'loadCompleted': '已加载全部数据',
    'modifyOwner': '修改拥有者',
    'selectOwner': '选择拥有者',
    'owner': '拥有者',
    'ownerDepartment': '拥有者部门',
    'modifyExplain': '修改说明',
    'placeholder': '请输入',
    'pleaseSelectOwner': '请选择拥有者',
    'selectedField': '已选字段',
    'numbers': '{num}个',
    'exportRecord': '导出记录',
    'unfinished': '未完成',
    'finished': '已完成',
    'exporting': '导出中',
    'reExport': '重新导出',
    'placeInputSearch': '请输入搜索内容',
    'placeInputModel': '请输入模型名称',
    'placeInputKey': '请输入关键字进行过滤',
    'noDataTree': '您关联的模型还未创建数据，无法设置查询条件',
    'noDataTree2': '您还未创建数据，无法设置层级关系',
    'noDataTree3': '没有符合匹配的数据',
    'treeDataLoading': '数据请求中,请稍后...',
    'Equal': '等于',
    'NoEqual': '不等于',
    'ISNULL': '为空',
    'ISNOTNULL': '不为空',
    'noData': '暂无数据',
    'fileName': '文件名称',
    'fileSize': '大小',
    'modelName': '模型名称',
    'exportTime': '导出时间',
    'operation': '操作',
    'ownerTip': '您选择的数据中有{num}条数据您没有修改拥有者的权限，系统将不修改这{num}条数据的拥有者。',
    'modifySuccess': '修改成功',
    'printformTips': '您选中的数据已超过{size}条，请删除部分数据或分批重新打印',
    'isCustomizePrintTemp': '当前数据没有设置自定义打印模板或者未启用打印模板功能',
    'selectDataTips': '有{num}条错误下拉框',
    'radioDataTips': '有{num}条错误单选框',
    'checkboxDataTips': '有{num}条错误复选框',
    'importDataTips': '无法匹配，请输入相同的选项内容',
    'tips': '提示：',
    'gotIt': "知道了",
    'complete': "完成",
    'batchUpdata': '批量修改',
    'batchUpdataRecord': '批量修改记录',
    'batchUpdataTips1': '业务数据项：图片、附件、地图、地址、手写签名、关联表单、关联查询字段不支持批量修改。',
    'batchUpdataTips2': '系统数据项：单据号、创建人、创建人部门、创建时间、修改时间、修改人不支持批量修改。',
    'batchUpdataTips3': '流程表单不能修改，只能修改业务表单。',
    'modifyField': '修改字段',
    'modifyValue': '修改值',
    'modifyData': '修改数据',
    'modifyFailed': '修改失败',
    'replaceWith': '替换为',
    'addResult': '新增结果',
    'filterCondition': '筛选条件',
    'importTitleBatchTips': '仅支持批量修正人员、部门',
    'all': "全部",
    'cacheFormData': '继续创建时，保留本次提交内容',
    'Submit&Creating': '提交并继续创建',
    'invalidForm': '该表单未发布，请联系管理员处理',
    'sysDefaultTemplate': '系统默认模板',
    'printTemplate': '打印模板',
    'FormTrackTable': {
        'DataTitle': '数据标题',
        'DataItem': '数据项',
        'Before': '变更前',
        'After': '变更后',
        'LoadedAll': '已加载完全部留痕记录',
    },
    'ListImportTips1': '选择或拖拽Excel文件上传',
    'ListImportTips2': '支持.xlsx格式，单次最多500条数据',
    'ListImportTips3': '为确保上传数据与列表内容匹配，请先下载',
    'ListImportTips4': '不支持导入流程数据，请仔细核对',
    'ListImportTips5': '数据标题、单据号仅支持覆盖导入',
    'ListImportTips6': '导入数据默认不触发业务规则，若要触发请查看开发者手册',
    'ListImportTips7': '允许覆盖数据，当 ',
    'ListImportTips8': ' 相同，则覆盖已有数据',
    'ListImportTips9': '数据导入中，请不要关闭页面',
    'ListImportTips10': '数据导入失败',
    'ListImportTips11': '数据导入完成',
    'ListImportTips12': '数据校验错误',
    'ListImportTips13': '导入失败，请重新导入',
    'ListImportTips14': '成功导入',
    'ListImportTips15': '条数据',
    'ListImportTips16': '条数据，有 ',
    'ListImportTips17': '条数据导入失败',
    'ListImportTips18': '请',
    'ListImportTips19': '下载错误数据',
    'ListImportTips20': '，修改后再导入',
    'ListImportTips21': '当前文件内的表单内容为空，请重新检查再导入数据',
    'ListImportTips22': '请参照',
    'ListImportTips23': '重新检查',
    'barcode': '条形码',
    'workflowLog': '流程日志',
    'workflowStamp': '流程印章',
    'approval': '审批',
    'systemAuto': '系统自动添加',
    'receiveTime': '接收时间',
    'finishTime': '完成时间',
    'usedTime': '耗时',
    'content': '处理意见',
};
